import { render, staticRenderFns } from "./Reboque.vue?vue&type=template&id=05018804"
import script from "./Reboque.vue?vue&type=script&lang=js"
export * from "./Reboque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports